/* eslint-disable max-len */
import React, { useContext} from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import AnimatedButton from '../../../../components/Animation/AnimatedButton'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { toggleRowSelection } from '../../../../redux/MultiselectRows'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'
import GlobalContext from '../../../../components/Context/GloablContext'
import { handleEditMessageSent } from '../../../../redux/systemConfigSlice'

const TableBody = ({ tableData,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    lastIndex,
    setConfirmationState,
    setSelectedRow,
    setTextAreaMsg }) => {

    const navigate = useNavigate()
    const auth = useSelector(state => state?.auth)
    const { userType } = auth
    const { setToastmessage,setToastErrorMessage ,sendMessageToStartEditing,receiveMessageFromSocket,editSocket,} = useContext(GlobalContext);
    const dispatch = useDispatch()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams, setSearchParams] = useSearchParams({})
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)

    /**
 * The function `handelActionButton` sets the selected index to the provided index number.
 */
    const handelActionButton = async (indexNum) => {
        setSelectedIndex(indexNum)
    }

    /**
     * The handleCheckboxChange function dispatches an action to toggle the row selection in a table.
     */
    const handleCheckboxChange = () => {
        dispatch(toggleRowSelection([tableData?.template_id, pageNumber.toString(), List.data, tableData?.template_name]))
    };

    /**
     * The function onClickDelete is triggered when a click event occurs, and it resets the text
     * area message, clears the selected index, opens a confirmation state, sets the row data, and
     * selects a row.
     */
    const onClickDelete = (e) => {
        e.preventDefault();
        setTextAreaMsg('');
        setSelectedIndex(null);
        setConfirmationState((prev) => ({
            ...prev,
            isOpen: true,
            rowData: tableData,
            multirow: ''
        }))
        setSelectedRow(tableData);
    }
    const createdDate=convertEpochToDateFormat(tableData?.created_at,dateformat)
    const upatedDate=convertEpochToDateFormat(tableData?.updated_at,dateformat)

    // const createdDate = dateformat?.includes('AM/PM') ? moment(tableData?.created_at)?.utcOffset('+05:30').format(`${dateformat.split(',')[0]} hh:mm:ss A`) : moment(tableData?.created_at)?.format(dateformat)

    // const upatedDate = dateformat?.includes('AM/PM') ? moment(tableData?.updated_at)?.utcOffset('+05:30').format(`${dateformat.split(',')[0]} hh:mm:ss A`) : moment(tableData?.updated_at)?.format(dateformat)


    return (
        <>
            <AnimatedList
                id={tableData.template_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={(e) => {
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        navigate(`/manage-device-templates/${tableData?._id}`, { state: Array.isArray(location.state) ? '' : { "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"),"search_mode": searchParams.get("search_mode"), 'search': searchParams.get("search") ? searchParams.get("search") : '' } })
                    }
                }}
                child={
                    <>
                        <td data-testid={`devicetemplate-check-${indexNum}`} className="px-[18px] py-2 text-sm text-start prevent-click font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            <div className="relative checkbox custom-checkBoxBlue1 provider-tbody">
                                <input type="checkbox" id={tableData._id} checked={selectedRows?.some((obj) => obj.id === tableData?.template_id) ? true : false} onChange={() => handleCheckboxChange()} className='prevent-click' />
                                <label htmlFor={tableData._id} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click"></label>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.template_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.template_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.manufacturer_name ? tableData.manufacturer_name : "-"}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.model ? tableData.model : "-"}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.template_creator}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{createdDate}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{upatedDate}</td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click ${selectedRows.map((item) => item.id).includes(tableData?.template_id) ? 'bg-[#F8EEF1]' : 'bg-white '} last-td`}>
                            <div className="relative flex items-center justify-center" data-te-dropdown-ref>
                                <button type='button' className="text-white transition duration-150 ease-in-out w-[40px] h-[34px] rounded-[50%] flex justify-center items-center prevent-click"
                                    id={"id"}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() => handelActionButton(indexNum)}
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    data-testid="action-bar"
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/3_dots_list.svg" alt="icon" className="prevent-click" />
                                </button>
                                {selectedIndex === indexNum && <ul style={{ marginRight: '2px' }} ref={selectedRef} className={`border border-[#C2DCEF] p-2.5 absolute z-[99] float-left m-0  ${lastIndex === indexNum + 1 ? ' top-[0px]' : ' top-0'} xl:right-[84px] right-[68px] min-w-[135px] list-none rounded-lg  bg-white bg-clip-padding text-left [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref >
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { }}
                                            buttonName={"View"}
                                            locnState={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"),"search_mode": searchParams.get("search_mode"), 'search': searchParams.get("search") ? searchParams.get("search") : '' }}
                                            link={`/manage-device-templates/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li className={`${(userType === 'admin-user' && tableData.user_type === "admin-user" || userType === 'corporate-user') ? 'hidden' : ''}`}>
                                        <AnimatedButton
                                            handleClick={() => {
                                                if(!messageSent){
                                               
                                                    sendMessageToStartEditing(tableData?.template_id)
                                                    let message
                                                    editSocket.onmessage = (event) =>{
                                                        message = event.data

                                                        if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                                                      
                                                            navigate(`/manage-device-templates/edit-device-template/${tableData._id}`,{state:{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),"search_mode":searchParams.get("search_mode"),'search':searchParams.get("search")?searchParams.get("search"):''}})
                                                        } else{
                                                            dispatch(handleEditMessageSent(false))
                                                        
                                                            { (JSON.parse(message)?.adminId) &&
                                                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this device template`)
                                                            }
                                                        }
                                                    }    
                                                }
                                            
                                            }}
                                            buttonName={"Edit"}
                                            locnState={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), 'search': searchParams.get("search") ? searchParams.get("search") : '' }}
                                            // link={`/manage-device-templates/edit-device-template/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li className={`${(userType === 'admin-user' && tableData.user_type === "admin-user") || (userType === 'corporate-user') ? 'hidden' : ''}`}>
                                        <AnimatedButton
                                            handleClick={(e) => { onClickDelete(e) }}
                                            buttonName={`Delete`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent  hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <div className='absolute top-[12px] right-[-9px] rotate-[45deg] w-4 h-4 border-t border-r border-[#C2DCEF] bg-[#fff] z-0'>
                                    </div>
                                </ul>}
                            </div>
                        </td>
                    </>
                } />
        </>
    )
}

export default TableBody